import React from 'react';

import { useMarginInstruments } from 'src/lib/margin/hooks/instruments';
import { HIDDEN_INDICATORS } from 'src/lib/margin/utils';
import { TradingViewWidget } from 'src/lib/trade/components';

const MarginTradeChart: React.FC = () => {
  const { secondaryCode, primaryCode, isLoading } = useMarginInstruments();

  return (
    <div className='h-full w-full'>
      {!isLoading && secondaryCode ? (
        <TradingViewWidget
          chartStyle='advanced'
          className='min-h-[50vh] md:min-h-[450px]'
          primary={primaryCode}
          secondary={secondaryCode}
          showChartStyleSwitch={false}
          showOverlays={false}
          showChangeSide={false}
          side='bid'
          hiddenIndicators={HIDDEN_INDICATORS}
        />
      ) : (
        <div className='h-full w-full animate-pulse rounded-16 bg-color-background-neutral' />
      )}
    </div>
  );
};

export { MarginTradeChart };
